var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detail-item"},[_c('div',{staticClass:"type"},[_c('p',[_vm._v("\n            "+_vm._s(_vm._f("__")(`quote-results.static.policy_includes`))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"price flex"},[_vm._v("\n        "+_vm._s(Object.keys(_vm.innerProps)
                .map((key) => _vm.$trans(`quote-results.${_vm.type}.${key}`))
                .join(", "))+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }